module.exports = __webpack_public_path__ + "static/media/04.f54c140e.jpg";